import { useOrganizationContext } from '@/contexts/organization-context';
import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@/components/shadcn/dialog';
import { Button } from '@/components/shadcn/button';
import { useToast } from '@/components/shadcn/use-toast';
import { useRouter } from 'next/router';
import { Spinner } from '@/components/basic/spinner';

const MutationOrganizationRemove = gql(`
  mutation OrganizationRemove($input: OrganizationRemoveInput!) {
    organization {
      remove(input: $input) {
        ... on OrganizationRemoveSuccess {
          result
        }
      }
    }
  }
`);

export function OrganizationDelete({ name }: any) {
  const { organizationId, setOrganizationId } = useOrganizationContext();
  const { toast } = useToast();
  const router = useRouter();
  const [organizationRemove, { loading }] = useMutation(
    MutationOrganizationRemove,
    {
      onCompleted: () => {
        setOrganizationId && setOrganizationId('');
        router.push('/');
      },
      onError: (error) => {
        toast({
          description: `Failed to delete organization: ${error.message}`,
          duration: 5000,
          variant: 'destructive',
        });
      },
    }
  );

  const handleOrganizationDelete = async () => {
    organizationRemove({
      variables: {
        input: {
          filters: {
            id: organizationId || '',
          },
        },
      },
    });
  };

  return (
    <div className='flex gap-4'>
      <Dialog>
        <DialogTrigger asChild>
          <Button disabled={loading} variant={'destructive'}>
            {loading ? (
              <Spinner className='m-2 w-4' color='#fff ' />
            ) : (
              `Delete ${name}`
            )}
          </Button>
        </DialogTrigger>
        <DialogContent className='sm:max-w-[425px]'>
          <p className='text-lg'>Would you like to delete {name}?</p>

          <div className='mt-4 flex justify-end gap-4'>
            <DialogClose asChild>
              <Button
                disabled={loading}
                variant='destructive'
                onClick={handleOrganizationDelete}
              >
                {loading ? (
                  <Spinner className='m-2 w-4' color='#fff ' />
                ) : (
                  `Delete ${name}`
                )}
              </Button>
            </DialogClose>
            <DialogClose asChild>
              <Button variant='ghost'>Close</Button>
            </DialogClose>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
